<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">代金券管理</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>平台：</label>
          <el-select v-model="platformType" placeholder="Select" style="width: 8em" @change="platformChange">
            <el-option v-for="item in platformTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>奖励券：</label>
          <el-select v-model="isAward" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in isAwardArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>新人券：</label>
          <el-select v-model="isNewbie" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in isNewbieArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>分享券：</label>
          <el-select v-model="isShare" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in isShareArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>会员券：</label>
          <el-select v-model="isVip" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in isVipArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" @click="editVoucherSysDialog(-1)">创建代金券</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            border
            @selection-change="selsChange"
            @header-click="selsAll"
            @cell-click="toggleSelection"
        >
          <el-table-column type="selection" width="55" align="center" class-name="cursor"/>
          <el-table-column property="id" label="编号" v-if="checkColList.indexOf('编号') > -1" ></el-table-column>
          <el-table-column property="name" label="名称" v-if="checkColList.indexOf('名称') > -1"></el-table-column>
          <el-table-column property="" label="类型信息" v-if="checkColList.indexOf('类型信息') > -1">
            <template #default="scope">
              <span>{{ scope.row.platformType == 1?'Android':scope.row.platformType ==2?'ios':scope.row.platformType ===4?'鸿蒙':'' }}</span>
            </template>
          </el-table-column>
          <el-table-column property="createTime" label="创建日期" v-if="checkColList.indexOf('创建日期') > -1" ></el-table-column>
          <el-table-column property="price" label="金额" v-if="checkColList.indexOf('金额') > -1"></el-table-column>
          <el-table-column property="useTypeName" label="可用商品类型" v-if="checkColList.indexOf('可用商品类型') > -1"></el-table-column>
          <el-table-column property="" label="最低购买金额" v-if="checkColList.indexOf('最低购买金额') > -1">
            <template #default="scope">
              <span>{{scope.row.minPay == 0?'不限':scope.row.minPay}}</span>
            </template>
          </el-table-column>
          <el-table-column property="" label="有效期" v-if="checkColList.indexOf('有效期') > -1">
            <template #default="scope">
              <p v-if="scope.row.effectiveDay != 0">{{scope.row.effectiveDay}}天</p>
              <p v-else>{{scope.row.effectiveMinute}}分钟</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
            <template #default="scope">
              <p>奖励券：{{scope.row.isAward == 0?'未设置':scope.row.isAward == 1?'已设置':''}}</p>
              <p>新人券：{{scope.row.isNewbie == 0?'未设置':scope.row.isNewbie == 1?'已设置':''}}</p>
              <p>分享券：{{scope.row.isShare == 0?'未设置':scope.row.isShare == 1?'已设置':''}}</p>
              <p>会员券：{{scope.row.isVip == 0?'未设置':scope.row.isVip == 1?'已设置':''}}</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1" width="240">
            <template #default="scope">
              <el-space wrap>
                <el-button type="success" size="small" v-if="scope.row.isAward == 0" @click="pass(scope.$index)" v-loading="scope.row['passLoading']">设为奖励券</el-button>
                <el-button type="warning" size="small" v-if="scope.row.isAward == 1" @click="reject(scope.$index)" v-loading="scope.row['rejectLoading']">取消奖励券</el-button>
                <el-button type="success" size="small" v-if="scope.row.isNewbie == 0"  @click="updateNewbie(scope.$index, 1)" v-loading="scope.row['updateNewbieLoading']">设为新人券</el-button>
                <el-button type="warning" size="small" v-if="scope.row.isNewbie == 1"  @click="updateNewbie(scope.$index, 0)" v-loading="scope.row['updateNewbieLoading']">取消新人券</el-button>
                <el-button type="success" size="small" v-if="scope.row.isShare == 0"  @click="updateShare(scope.$index, 1)" v-loading="scope.row['updateShareLoading']">设为分享券</el-button>
                <el-button type="warning" size="small" v-if="scope.row.isShare == 1"  @click="updateShare(scope.$index, 0)" v-loading="scope.row['updateShareLoading']">取消分享券</el-button>
                <el-button type="success" size="small" v-if="scope.row.isVip == 0"  @click="updateVip(scope.$index, 1)" v-loading="scope.row['updateVipLoading']">设为会员券</el-button>
                <el-button type="warning" size="small" v-if="scope.row.isVip == 1"  @click="updateVip(scope.$index, 0)" v-loading="scope.row['updateVipLoading']">取消会员券</el-button>
                <el-button type="danger" size="small" @click="del(scope.$index)" v-loading="scope.row['delLoading']">删除</el-button>
                <el-button size="small" v-if="scope.row.isSend == 0" @click="editVoucherSysDialog(scope.$index,scope.row)" type="primary">编辑</el-button>
              </el-space>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
// import BtnGroup from '../../components/BtnGroup'
import { getVoucherSysPageList, updateVoucherSysAward, updateVoucherSysDel, updateVoucherSysNewbie,updateVoucherSysShare, updateVoucherSysVip } from '@/api/url'
import {getFormData, postFormData} from '@/api/api'
import Dialog from "@/assets/js/dialog";
import voucherSysDialog from "./components/voucherSysDialog";
import DatePickerRange from '../../components/DatePickerRange'

export default {
  name: "VoucherSys",
  components: { DatePickerRange },
  data() {
    return {

      isAwardArray: [
        {label: "不限",value: -1},
        {label: "已设置",value: 1},
        {label: "未设置",value: 0}
      ],
      isAward: -1,

      isNewbieArray: [
        {label: "不限",value: -1},
        {label: "已设置",value: 1},
        {label: "未设置",value: 0}
      ],
      isNewbie: -1,

      isShareArray: [
        {label: "不限",value: -1},
        {label: "已设置",value: 1},
        {label: "未设置",value: 0}
      ],
      isShare: -1,

      isVipArray: [
        {label: "不限",value: -1},
        {label: "已设置",value: 1},
        {label: "未设置",value: 0}
      ],
      isVip: -1,

      platformTypeArray: [
        {label:'不限', value:-1},
        {label:'安卓', value:1},
        // {label:'IOS', value:2},
        {label:'鸿蒙', value:4},
      ],
      platformType: -1,

      //选中id
      idArray: [],

      //刷新组
      colList: ['编号', '名称', '类型信息', '创建日期', '金额', '可用商品类型', '最低购买金额', '有效期', '状态', '操作'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      searchLoading: false,
      listLoading: false,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,
    }
  },
  methods: {

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },

    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.isAward = -1;
      this.isNewbie = -1;
      this.isShare = -1;
      this.isVip = -1;
      this.platformType = -1;
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['isAward'] = this.isAward;
      param['isNewbie'] = this.isNewbie;
      param['isShare'] = this.isShare;
      param['isVip'] = this.isVip;
      param['platformType'] = this.platformType;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getVoucherSysPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch(() => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    editVoucherSysDialog(idx, row) {
      let _title = '';
      let voucherSysForm = {}
      if (idx > -1) {
        _title = '编辑代金券'
        voucherSysForm = Object.assign({}, row);
      }else {
        _title = '创建代金券'
      }
      Dialog.open({
        title: _title,
        component: voucherSysDialog,
        data: {
          voucherSysForm: voucherSysForm,
          ids: idx,
          width: '700px'
        },
        confirm: (result) => {
            this.getPage()
        }
      })
    },

    toggleSelection(row, column, cell, event) {

      if (column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

    },

    //设为奖励券
    pass(idx) {
      this.$confirm('你确定要设置【' + this.pageDataList[idx]['name'] + '】为奖励券么？').then(() => {
        this.pageDataList[idx]['passLoading'] = true;
        this.updateState(idx, 1);
      })
          .catch(() => {})
    },

    //取消奖励券
    reject(idx) {
      this.$confirm('你确定要取消【' + this.pageDataList[idx]['name'] + '】的奖励券么？').then(() => {
        this.pageDataList[idx]['rejectLoading'] = true;
        this.updateState(idx, 0);
      })
          .catch(() => {})
    },

    //状态更新
    updateState(idx,isAward) {
      let _this = this;
      let param = {};
      param['id'] = this.pageDataList[idx]['id'];
      param['isAward'] = isAward;
      postFormData(updateVoucherSysAward,param).then((data) => {
        let {code,msg} = data;
        if(code == 200) {
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          });
          _this.pageDataList[idx]['isAward'] = isAward
        }else{
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          });
        }
        _this.pageDataList[idx]['passLoading'] = false;
        _this.pageDataList[idx]['rejectLoading'] = false;
      })
          .catch((data) => {
            _this.pageDataList[idx]['passLoading'] = false;
            _this.pageDataList[idx]['rejectLoading'] = false;
          })
    },

    //删除奖励券
    del(idx){
      this.$confirm('你确定要删除【' + this.pageDataList[idx]['name'] + '】这张代金券么？').then(() => {
        this.pageDataList[idx]['delLoading'] = true;
        let _this = this;
        let param = {};
        param['id'] = this.pageDataList[idx]['id']
        postFormData(updateVoucherSysDel,param).then((data) => {
          let {code,msg} = data;
          if(code == 200) {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            _this.pageDataList.splice(idx, 1);
          }else{
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
          _this.pageDataList[idx]['delLoading'] = false;
        })
      })
          .catch(() => {})
    },

    // 更新新人券状态
    updateNewbie(idx, state) {
      this.$confirm('你确定要' + (state == 1 ? '设置【' : '取消【') + this.pageDataList[idx]['name'] + '】为新人券么？').then(() => {
        this.pageDataList[idx]['updateNewbieLoading'] = true;
        let param = {};
        param['id'] = this.pageDataList[idx]['id'];
        param['isNewbie'] = state;
        postFormData(updateVoucherSysNewbie,param).then((data) => {
          let {code,msg} = data;
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            this.pageDataList[idx]['isNewbie'] = state
          }else{
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
          this.pageDataList[idx]['updateNewbieLoading'] = false;
          this.$set(this.pageDataList, idx, this.pageDataList[idx]);
        })
            .catch((data) => {
              this.pageDataList[idx]['updateNewbieLoading'] = false;
              this.$set(this.pageDataList, idx, this.pageDataList[idx]);
            })
      })
          .catch(() => {})
    },

    // 更新新人券状态
    updateShare(idx, state) {
      this.$confirm('你确定要' + (state == 1 ? '设置【' : '取消【') + this.pageDataList[idx]['name'] + '】为分享券么？').then(() => {
        this.pageDataList[idx]['updateShareLoading'] = true;
        let param = {};
        param['id'] = this.pageDataList[idx]['id'];
        param['isShare'] = state;
        postFormData(updateVoucherSysShare,param).then((data) => {
          let {code,msg} = data;
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            this.pageDataList[idx]['isShare'] = state
          }else{
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
          this.pageDataList[idx]['updateShareLoading'] = false;
          this.$set(this.pageDataList, idx, this.pageDataList[idx]);
        })
            .catch((data) => {
              this.pageDataList[idx]['updateShareLoading'] = false;
              this.$set(this.pageDataList, idx, this.pageDataList[idx]);
            })
      })
          .catch(() => {})
    },

    // 更新会员券状态
    updateVip(idx, state) {
      this.$confirm('你确定要' + (state == 1 ? '设置【' : '取消【') + this.pageDataList[idx]['name'] + '】为会员券么？').then(() => {
        this.pageDataList[idx]['updateVipLoading'] = true;
        let param = {};
        param['id'] = this.pageDataList[idx]['id'];
        param['isVip'] = state;
        postFormData(updateVoucherSysVip,param).then((data) => {
          let {code,msg} = data;
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            this.pageDataList[idx]['isVip'] = state
          }else{
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
          this.pageDataList[idx]['updateVipLoading'] = false;
          this.$set(this.pageDataList, idx, this.pageDataList[idx]);
        })
            .catch((data) => {
              this.pageDataList[idx]['updateVipLoading'] = false;
              this.$set(this.pageDataList, idx, this.pageDataList[idx]);
            })
      })
          .catch(() => {})
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
